import getEndPoint from "./getEndpoint.js";
import { getReduxValue } from "./redux.js";

let cachedVisitorId = "";

// export const generateSessionId = () => {
//   let id = sessionStorage.getItem("viz_session_id");

//   if (!id) {
//     // Safe UUID generation for all browsers
//     if (typeof crypto !== "undefined" && crypto.randomUUID) {
//       id = crypto.randomUUID();
//     } else {
//       // Fallback for mobile / older browsers
//       id = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
//     }

//     sessionStorage.setItem("viz_session_id", id);
//   }

//   return id;
// };

export const generateVisitorId = () => {
  if (cachedVisitorId) {
    return cachedVisitorId;
  }

  const storage =
    typeof window !== "undefined" && window.localStorage
      ? window.localStorage
      : null;

  try {
    let id = storage?.getItem("viz_visitor_id");

    if (!id) {
      if (typeof crypto !== "undefined" && crypto.randomUUID) {
        id = crypto.randomUUID();
      } else {
        id = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      }

      storage?.setItem("viz_visitor_id", id);
    }

    cachedVisitorId = id;
    return id;
  } catch {
    if (!cachedVisitorId) {
      if (typeof crypto !== "undefined" && crypto.randomUUID) {
        cachedVisitorId = crypto.randomUUID();
      } else {
        cachedVisitorId = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      }
    }
    return cachedVisitorId;
  }
};

const normalizePathname = (pathname = "") => {
  if (typeof pathname !== "string") return "/";
  const trimmed = pathname.trim().replace(/\/+$/, "");
  return trimmed || "/";
};

export const getAnalyticsContext = (pathname = "") => {
  const normalizedPathname = normalizePathname(pathname);

  if (normalizedPathname === "/") {
    return { pageName: "home", publicationId: null };
  }

  if (normalizedPathname === "/signup") {
    return { pageName: "signup", publicationId: null };
  }

  if (normalizedPathname === "/verify-otp") {
    return { pageName: "verify-otp", publicationId: null };
  }

  if (normalizedPathname === "/login") {
    return { pageName: "login", publicationId: null };
  }

  if (normalizedPathname === "/reset-password") {
    return { pageName: "reset-password", publicationId: null };
  }

  if (normalizedPathname === "/reset-password-verify-otp") {
    return { pageName: "reset-password-verify-otp", publicationId: null };
  }

  if (normalizedPathname === "/visualizations") {
    return { pageName: "visualizations", publicationId: null };
  }

  if (normalizedPathname.startsWith("/f/visualizations")) {
    return { pageName: "visualizations-folder", publicationId: null };
  }

  if (normalizedPathname.startsWith("/v/visualizations")) {
    const segments = normalizedPathname.split("/").filter(Boolean);
    const publicationId = segments.length > 2 ? segments[segments.length - 1] : null;
    return { pageName: "visualization-detail", publicationId };
  }

  if (normalizedPathname === "/privacy") {
    return { pageName: "privacy", publicationId: null };
  }

  if (normalizedPathname === "/terms") {
    return { pageName: "terms", publicationId: null };
  }

  if (normalizedPathname === "/about") {
    return { pageName: "about", publicationId: null };
  }

  if (normalizedPathname === "/errors") {
    return { pageName: "errors", publicationId: null };
  }

  if (normalizedPathname === "/admin") {
    return { pageName: "admin", publicationId: null };
  }

  if (normalizedPathname === "/studio") {
    return { pageName: "studio", publicationId: null };
  }

  if (normalizedPathname === "/studio/visualizations") {
    return { pageName: "studio-visualizations", publicationId: null };
  }

  if (normalizedPathname === "/studio/visualizations/new") {
    return { pageName: "studio-visualization-new", publicationId: null };
  }

  if (normalizedPathname.startsWith("/studio/visualizations/")) {
    return { pageName: "studio-visualization-edit", publicationId: null };
  }

  if (normalizedPathname.startsWith("/studio/folders")) {
    return { pageName: "studio-folders", publicationId: null };
  }

  if (normalizedPathname === "/studio/animations") {
    return { pageName: "studio-animations", publicationId: null };
  }

  if (normalizedPathname === "/studio/animations/new") {
    return { pageName: "studio-animation-new", publicationId: null };
  }

  if (normalizedPathname.startsWith("/studio/animations/")) {
    return { pageName: "studio-animation-edit", publicationId: null };
  }

  if (normalizedPathname === "/profile/me") {
    return { pageName: "my-profile", publicationId: null };
  }

  if (normalizedPathname.startsWith("/profile/")) {
    return { pageName: "profile", publicationId: null };
  }

  if (normalizedPathname === "/settings") {
    return { pageName: "settings", publicationId: null };
  }

  if (normalizedPathname === "/my-access") {
    return { pageName: "my-access", publicationId: null };
  }

  if (normalizedPathname.startsWith("/export/")) {
    return { pageName: "export", publicationId: null };
  }

  return { pageName: "not-found", publicationId: null };
};

export const sendAnalytics = (payload) => {
  const BASE_URL = import.meta.env.VITE_API_BASE_URL;
  const url = BASE_URL + getEndPoint("analytics", "postAnalytics").path;

  const body = JSON.stringify(payload);
  const accessToken = getReduxValue("auth.accessToken");

  if (
    !accessToken &&
    typeof navigator !== "undefined" &&
    navigator.sendBeacon
  ) {
    const blob = new Blob([body], {
      type: "application/json",
    });
    navigator.sendBeacon(url, blob);
  } else {
    void fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      body,
      keepalive: true,
    }).catch(() => {});
  }
};
